import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { TicketBatch } from './ticket-batch';
import { Ticket } from './ticket';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';
import { TicketBatchTicketSpare } from './ticket-batch-ticket-spare';

export class TicketBatchTicket extends BaseEntity {

  id                : number      ;
  ticketBatch       : TicketBatch	;
  ticket            : Ticket	    ;
  visitDate	        : Date	      ;
  done	            : boolean	    ;
  feedback	        : string	    ;
  duration          : number      ;
  rank              : number      ;

  barCode           : string      ;
  document          : string      ;


  // Transient
	ticketBatchTicketSpares      : TicketBatchTicketSpare[];
  assetProducts                : AssetProduct[] ;
  

  constructor() {
    super();

  }
}
